import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Icons from 'assets/images/Icons';

import useLowHashrateAlert from './useLowHashrateAlert';

import './WorkerAlertBanner.scss';

// Proactive, actionable alert for workers whose current hashrate has fallen
// below their configured alert_limit (backend sets status === 'low'). The count
// comes from /api/dashboard/totals (workers_low), already fetched by the
// dashboard/workers pages. Renders nothing when no worker is low, or after the
// user dismisses the current situation; any change in the count re-surfaces it.
const WorkerAlertBanner = ({ count }: { count?: number }) => {
  const low = count ?? 0;
  const [dismissedCount, setDismissedCount] = useState<number | null>(null);

  useLowHashrateAlert(count);

  if (low === 0 || dismissedCount === low) {
    return null;
  }

  const plural = low > 1;

  return (
    <article className='worker-alert-banner' role='alert'>
      <div className='worker-alert-banner__icon'>
        <Icons name='Down' />
      </div>
      <div className='worker-alert-banner__message'>
        <strong>
          {low} worker{plural ? 's are' : ' is'} below the hashrate alert limit
        </strong>
        <span>
          Hashrate has dropped under the limit you set for {plural ? 'these workers' : 'this worker'}.
        </span>
      </div>
      <Link className='worker-alert-banner__action' to='/workers?status=low'>
        View
      </Link>
      <button
        className='worker-alert-banner__close'
        type='button'
        aria-label='Dismiss low-hashrate alert'
        onClick={() => setDismissedCount(low)}
      >
        <Icons name='Cancel' />
      </button>
    </article>
  );
};

export default WorkerAlertBanner;
